<script>
import { Cell, Popup, Picker } from 'vant'
import Common from '@/tbs/model/to/Common'

const common = new Common

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'shortcut-date-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-picker': Picker
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        down: Number,
        up: Number,
        min: Number,
        max: Number,
        unit: String,
        disabled: Boolean,
        readonly: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            columns: [],
            downValue: -1,
            upValue: -1,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        rangeLabel() {
            const selectedLabel = ''
            const unit = this.unit || ''
            if (this.downValue > 0 && this.upValue > 0) {
                if (this.downValue < this.upValue) {
                    return common.localeProp('between-min-max', {
                        min: this.downValue,
                        max: this.upValue,
                        unit: unit
                    })
                }
                else if (this.downValue == this.upValue) {
                    return common.localeProp('exact-num', {
                        num: this.downValue, 
                        unit: unit
                    })
                }
            }
            else if (this.downValue > 0 && this.upValue == 0) {
                return common.localeProp('no-less', {
                    num: this.downValue, 
                    unit: unit
                })
            }
            else if (this.upValue > 0 && this.downValue == 0) {
                return common.localeProp('no-more', {
                    num: this.upValue, 
                    unit: unit
                })
            }
            else if (this.downValue == 0 && this.upValue == 0) {
                return common.localeProp('no-limit')
            }
            return selectedLabel
        }
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        down(value) {
            this.downValue = value
        },
        up(value) {
            this.upValue = value
        },
    },

    mounted() {
        this.downValue = this.down
        this.upValue = this.up
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onItemClick() {
            console.log('onItemClick')
            if (!this.disabled && !this.readonly) {
                this.calcColumns(this.downValue, this.upValue)
                this.showPopup = true
            }
        },
        onCancelBtnClick() {
            console.log('onCancelBtnClick')
            /*this.downValue = 0
            this.upValue = 0
            this.$emit('change-data', {
                min: 0,
                max: 0
            })*/
            this.showPopup = false
        },
        onConfirmBtnClick(values) {
            console.log('onConfirmBtnClick', arguments)
            this.downValue = values[0].value
            this.upValue = values[1].value
            this.$emit('change-data', {
                min: this.downValue,
                max: this.upValue
            })
            this.showPopup = false
        },
        onDataChange(target, values, columnIndex) {
            console.log('onDataChange', arguments)
            if (columnIndex == 0) {
                const downValue = values[0].value
                if (downValue != this.downValue) {
                    this.calcColumns(downValue, this.upValue)
                }
            }
        },
        calcColumns(down, up) {
            console.log('calcColumns', down, up, this.min, this.max)
            const min = this.min || 1
            const max = this.max || 99
            const downVal = Math.max(down, min)
            let upVal = Math.max(up, downVal)
            upVal = Math.min(upVal, max)

            let downIndex = -1
            const downValues = []
            if (!this.min) {
                downValues.push(
                    { text: common.localeProp('no-limit'), value: 0 }
                )
                downIndex++
            }
            
            for (let i = min; i <= max; i++) {
                if (downVal >= i) {
                    downIndex++
                }
                downValues.push({
                    text: i.toString(),
                    value: i
                })
            }
            
            let upIndex = -1
            const upValues = []
            if (!this.max) {
                upValues.push(
                    { text: common.localeProp('no-limit'), value: 0 }
                )
                upIndex++
            }
            
            for (let i = downVal; i <= max; i++) {
                if (upVal >= i) {
                    upIndex++
                }
                upValues.push({
                    text: i.toString(),
                    value: i
                })
            }

            if (down == 0) {
                downIndex = 0
            }
            if (up == 0) {
                upIndex = 0
            }
            
            this.columns = [
                { values: downValues, defaultIndex: downIndex },
                { values: upValues, defaultIndex: upIndex },
            ]
        }
    },
}
</script>

<template>
    <!-- component -->
    <div class="numeric-range-selector van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :class="{ disabled: disabled }"
            :title="label"
            :is-link="!disabled && !readonly"
            center
            :value="rangeLabel"
            @click="onItemClick"
        />
        <van-popup 
            v-model="showPopup"
            position="bottom"
        >
            <van-picker
                show-toolbar
                :title="label"
                :columns="columns"
                @cancel="onCancelBtnClick"
                @confirm="onConfirmBtnClick"
                @change="onDataChange"
            />
        </van-popup>
    </div>
</template>